
import { CONSTANTS } from '../constants';

    export default {
        data: () => ({
          TIMELINE : CONSTANTS.TIMELINE
        })
    }
